// 'use client';
// import { useState, useEffect } from 'react';
// import Image from 'next/image';
// import Button from '@/components/ui/Button';
// import Link from 'next/link';

// export default function HeroSection() {
//   const [mounted, setMounted] = useState(false);

//   useEffect(() => {
//     setMounted(true);
//   }, []);

//   if (!mounted) {
//     return (
//       <section className="w-full bg-[#200162] relative min-h-[400px] sm:min-h-[600px] md:min-h-[810px]">
//         <div className="absolute inset-0 bg-[#00000049]">
//           <div className="flex justify-center items-center h-full">
//             <div className="animate-pulse bg-white bg-opacity-20 rounded-lg h-32 w-64"></div>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section className="w-full bg-[#200162] relative min-h-screen">
//       {/* Background Image */}
//       <div className="absolute inset-0">
//         <Image
//           src="/images/hero-bg.webp"
//           alt="Background"
//           fill
//           className="object-cover"
//           unoptimized
//           priority
//         />
//       </div>

//       {/* Overlay */}
//       <div className="absolute inset-0 bg-[#00000049]"></div>

//       {/* Content */}
//       <div className="relative z-10 w-full h-full">
//         <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-[56px] min-h-screen flex flex-col items-center justify-center text-center">
//           {/* Heading + Description */}
//           <div className="flex flex-col items-center gap-6 sm:gap-8 md:gap-10 mb-8 sm:mb-12 md:mb-[68px] w-full">

//             {/* Heading */}
//             <h1
//               className="text-[45px] sm:text-[60px] md:text-[75px] lg:text-[89px] font-instrument font-medium leading-[55px] sm:leading-[73px] md:leading-[91px] lg:leading-[109px] text-white"
//               style={{
//                 textShadow: '8px 8px 69px rgba(110, 52, 234, 0.25)',
//               }}
//             >
//               Bridge Chains, Build Together
//             </h1>

//             {/* Description */}
//             <p
//               className="text-[18px] sm:text-[18px] md:text-[22px] lg:text-[21px] font-instrument font-normal leading-[26px] text-white w-full lg:w-[60%]"
//               style={{
//                 textShadow: '6px 6px 56px rgba(110, 52, 234, 0.25)',
//               }}
//             >
//               At <span className="font-semibold">Blockverse Series</span>, we bring together communities across diverse blockchain ecosystems — from builders & investors to founders & enthusiasts.
//               <br />
//               We create space for shared learning, partnerships & real innovation across the <span className="font-semibold">Web3 world</span>.
//             </p>
//           </div>

//         {/* Action Buttons */}
//           <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 md:gap-8 w-full max-w-[700px] mx-auto justify-center">
//             <Link href='https://luma.com/BlockverseSeries?k=c' target="_blank"
//                   rel="noopener noreferrer nofollow">
//             <Button
//               text="Join Blockverse Series"
//               text_font_size="text-[14px] sm:text-[16px] md:text-[18px]"
//               text_font_family="font-instrument"
//               text_font_weight="font-semibold"
//               text_line_height="leading-[17px] sm:leading-[20px] md:leading-[22px]"
//               text_color="text-white"
//               fill_background_color="bg-[#6e34ea]"
//               border_border_radius="rounded-[30px]"
//               className="w-full sm:w-auto px-[22px] sm:px-[29px] md:px-[36px] lg:px-[44px] py-[14px] sm:py-[16px] md:py-[18px] gap-[8px]"
//             />
//             </Link>
//             <Link href='http://t.me/blockverseseries' target="_blank"
//                   rel="noopener noreferrer nofollow">
//             <Button
//               text="Become a Member"
//               text_font_size="text-[14px] sm:text-[16px] md:text-[18px]"
//               text_font_family="font-instrument"
//               text_font_weight="font-semibold"
//               text_line_height="leading-[17px] sm:leading-[20px] md:leading-[22px]"
//               text_color="text-[#6e34ea]"
//               fill_background_color="bg-white"
//               border_border="border-[3px] border-solid border-[#5b17b4]"
//               border_border_radius="rounded-[30px]"
//               className="w-full sm:w-auto px-[23px] sm:px-[32px] md:px-[42px] lg:px-[46px] py-[14px] sm:py-[16px] md:py-[18px] gap-[4px]"
//             />
//             </Link>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// }


import Image from 'next/image';
import Button from '@/components/ui/Button';
import Link from 'next/link';

export default function HeroSection() {
  return (
    <section data-component-id="src/app/HeroSection.tsx:118:4" data-component-path="src/app/HeroSection.tsx" data-component-line="118" data-component-end-line="198" data-component-file="HeroSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22w-full%20bg-%5B%23200162%5D%20relative%20min-h-screen%22%7D" className="w-full bg-[#200162] relative min-h-screen">
      {/* Background Image */}
      <div data-component-id="src/app/HeroSection.tsx:120:6" data-component-path="src/app/HeroSection.tsx" data-component-line="120" data-component-end-line="129" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%22%7D" className="absolute inset-0">
        <Image data-component-id="src/app/HeroSection.tsx:121:8" data-component-path="src/app/HeroSection.tsx" data-component-line="121" data-component-end-line="128" data-component-file="HeroSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fimages%2Fhero-bg.webp%22%2C%22alt%22%3A%22Background%22%2C%22className%22%3A%22object-cover%22%7D"
          src="/images/hero-bg.webp"
          alt="Background"
          fill
          className="object-cover"
          unoptimized
          priority
        />
      </div>

      {/* Overlay */}
      <div data-component-id="src/app/HeroSection.tsx:132:6" data-component-path="src/app/HeroSection.tsx" data-component-line="132" data-component-end-line="132" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-%5B%2300000049%5D%22%7D" className="absolute inset-0 bg-[#00000049]"></div>

      {/* Content */}
      <div data-component-id="src/app/HeroSection.tsx:135:6" data-component-path="src/app/HeroSection.tsx" data-component-line="135" data-component-end-line="197" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20z-10%20w-full%20h-full%22%7D" className="relative z-10 w-full h-full">
        <div data-component-id="src/app/HeroSection.tsx:136:8" data-component-path="src/app/HeroSection.tsx" data-component-line="136" data-component-end-line="196" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1440px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-%5B56px%5D%20min-h-screen%20flex%20flex-col%20items-center%20justify-center%20text-center%22%7D" className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-[56px] min-h-screen flex flex-col items-center justify-center text-center">
          {/* Heading + Description */}
          <div data-component-id="src/app/HeroSection.tsx:138:10" data-component-path="src/app/HeroSection.tsx" data-component-line="138" data-component-end-line="161" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%20gap-6%20sm%3Agap-8%20md%3Agap-10%20mb-8%20sm%3Amb-12%20md%3Amb-%5B68px%5D%20w-full%22%7D" className="flex flex-col items-center gap-6 sm:gap-8 md:gap-10 mb-8 sm:mb-12 md:mb-[68px] w-full">

            {/* Heading */}
            <h1 data-component-id="src/app/HeroSection.tsx:141:12" data-component-path="src/app/HeroSection.tsx" data-component-line="141" data-component-end-line="148" data-component-file="HeroSection.tsx" data-component-name="h1" data-component-content="%7B%22elementName%22%3A%22h1%22%2C%22className%22%3A%22text-%5B45px%5D%20sm%3Atext-%5B60px%5D%20md%3Atext-%5B75px%5D%20lg%3Atext-%5B89px%5D%20font-instrument%20font-medium%20leading-%5B55px%5D%20sm%3Aleading-%5B73px%5D%20md%3Aleading-%5B91px%5D%20lg%3Aleading-%5B109px%5D%20text-white%22%2C%22textContent%22%3A%22Bridge%20Chains%2C%20Build%20Together%22%7D"
              className="text-[45px] sm:text-[60px] md:text-[75px] lg:text-[89px] font-instrument font-medium leading-[55px] sm:leading-[73px] md:leading-[91px] lg:leading-[109px] text-white"
              style={{
                textShadow: '8px 8px 69px rgba(110, 52, 234, 0.25)',
              }}
            >
              Bridge Chains, Build Together
            </h1>

            {/* Description */}
            <p data-component-id="src/app/HeroSection.tsx:151:12" data-component-path="src/app/HeroSection.tsx" data-component-line="151" data-component-end-line="160" data-component-file="HeroSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B18px%5D%20sm%3Atext-%5B18px%5D%20md%3Atext-%5B22px%5D%20lg%3Atext-%5B21px%5D%20font-instrument%20font-normal%20leading-%5B26px%5D%20text-white%20w-full%20lg%3Aw-%5B60%25%5D%22%2C%22textContent%22%3A%22At%20%2C%20we%20bring%20together%20communities%20across%20diverse%20blockchain%20ecosystems%20%E2%80%94%20from%20builders%20%26%20investors%20to%20founders%20%26%20enthusiasts.%20We%20create%20space%20for%20shared%20learning%2C%20partnerships%20%26%20real%20innovation%20across%20the%20.%22%7D"
              className="text-[18px] sm:text-[18px] md:text-[22px] lg:text-[21px] font-instrument font-normal leading-[26px] text-white w-full lg:w-[60%]"
              style={{
                textShadow: '6px 6px 56px rgba(110, 52, 234, 0.25)',
              }}
            >
              At <span data-component-id="src/app/HeroSection.tsx:157:17" data-component-path="src/app/HeroSection.tsx" data-component-line="157" data-component-end-line="157" data-component-file="HeroSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-semibold%22%2C%22textContent%22%3A%22Blockverse%20Series%22%7D" className="font-semibold">Blockverse Series</span>, we bring together communities across diverse blockchain ecosystems — from builders & investors to founders & enthusiasts.
              <br data-component-id="src/app/HeroSection.tsx:158:14" data-component-path="src/app/HeroSection.tsx" data-component-line="158" data-component-end-line="158" data-component-file="HeroSection.tsx" data-component-name="br" data-component-content="%7B%22elementName%22%3A%22br%22%7D" />
              We create space for shared learning, partnerships & real innovation across the <span data-component-id="src/app/HeroSection.tsx:159:93" data-component-path="src/app/HeroSection.tsx" data-component-line="159" data-component-end-line="159" data-component-file="HeroSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-semibold%22%2C%22textContent%22%3A%22Web3%20world%22%7D" className="font-semibold">Web3 world</span>.
            </p>
          </div>

        {/* Action Buttons */}
          <div data-component-id="src/app/HeroSection.tsx:164:10" data-component-path="src/app/HeroSection.tsx" data-component-line="164" data-component-end-line="194" data-component-file="HeroSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20sm%3Aflex-row%20gap-4%20sm%3Agap-6%20md%3Agap-8%20w-full%20max-w-%5B700px%5D%20mx-auto%20justify-center%22%7D" className="flex flex-col sm:flex-row gap-4 sm:gap-6 md:gap-8 w-full max-w-[700px] mx-auto justify-center">
            <Link data-component-id="src/app/HeroSection.tsx:165:12" data-component-path="src/app/HeroSection.tsx" data-component-line="165" data-component-end-line="178" data-component-file="HeroSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22https%3A%2F%2Fluma.com%2FBlockverseSeries%3Fk%3Dc%22%7D" href='https://luma.com/BlockverseSeries?k=c' target="_blank"
                  rel="noopener noreferrer nofollow">
            <Button data-component-id="src/app/HeroSection.tsx:167:12" data-component-path="src/app/HeroSection.tsx" data-component-line="167" data-component-end-line="177" data-component-file="HeroSection.tsx" data-component-name="Button" data-component-content="%7B%22elementName%22%3A%22Button%22%2C%22className%22%3A%22w-full%20sm%3Aw-auto%20px-%5B22px%5D%20sm%3Apx-%5B29px%5D%20md%3Apx-%5B36px%5D%20lg%3Apx-%5B44px%5D%20py-%5B14px%5D%20sm%3Apy-%5B16px%5D%20md%3Apy-%5B18px%5D%20gap-%5B8px%5D%22%7D"
              text="Join Blockverse Series"
              text_font_size="text-[14px] sm:text-[16px] md:text-[18px]"
              text_font_family="font-instrument"
              text_font_weight="font-semibold"
              text_line_height="leading-[17px] sm:leading-[20px] md:leading-[22px]"
              text_color="text-white"
              fill_background_color="bg-[#6e34ea]"
              border_border_radius="rounded-[30px]"
              className="w-full sm:w-auto px-[22px] sm:px-[29px] md:px-[36px] lg:px-[44px] py-[14px] sm:py-[16px] md:py-[18px] gap-[8px]"
            />
            </Link>
            <Link data-component-id="src/app/HeroSection.tsx:179:12" data-component-path="src/app/HeroSection.tsx" data-component-line="179" data-component-end-line="193" data-component-file="HeroSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22http%3A%2F%2Ft.me%2Fblockverseseries%22%7D" href='http://t.me/blockverseseries' target="_blank"
                  rel="noopener noreferrer nofollow">
            <Button data-component-id="src/app/HeroSection.tsx:181:12" data-component-path="src/app/HeroSection.tsx" data-component-line="181" data-component-end-line="192" data-component-file="HeroSection.tsx" data-component-name="Button" data-component-content="%7B%22elementName%22%3A%22Button%22%2C%22className%22%3A%22w-full%20sm%3Aw-auto%20px-%5B23px%5D%20sm%3Apx-%5B32px%5D%20md%3Apx-%5B42px%5D%20lg%3Apx-%5B46px%5D%20py-%5B14px%5D%20sm%3Apy-%5B16px%5D%20md%3Apy-%5B18px%5D%20gap-%5B4px%5D%22%7D"
              text="Become a Member"
              text_font_size="text-[14px] sm:text-[16px] md:text-[18px]"
              text_font_family="font-instrument"
              text_font_weight="font-semibold"
              text_line_height="leading-[17px] sm:leading-[20px] md:leading-[22px]"
              text_color="text-[#6e34ea]"
              fill_background_color="bg-white"
              border_border="border-[3px] border-solid border-[#5b17b4]"
              border_border_radius="rounded-[30px]"
              className="w-full sm:w-auto px-[23px] sm:px-[32px] md:px-[42px] lg:px-[46px] py-[14px] sm:py-[16px] md:py-[18px] gap-[4px]"
            />
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
}
